import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalGenericComponent } from '../../../../../shared/components/modal-generic/modal-generic.component';
import { AuthService } from '../../../../../shared/services/auth/auth.service';
import { MIN_STATUS } from '../../../../../shared/utils/constants';
import { ConfirmationService } from '../../../../../vass-core/components/modal/confirmation.service';

@Component({
  selector: 'app-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss'],
  standalone: false,
})
export class StatusBarComponent implements OnInit {
  public status = 0;
  public isRejected = false;

  public minStatus = MIN_STATUS;

  constructor(
    private confirmationService: ConfirmationService,
    private authService: AuthService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.getStatus();
    this.getRejectedMortgage();
  }

  // public changeStatus(num) {
  //     if (num) {
  //         this.authService.setStatus(num);
  //     }
  // }

  private getStatus() {
    this.authService.getStatus().subscribe((status) => {
      if (status && status.toString().indexOf('.') > 0) {
        this.status = parseFloat(status);
      } else {
        this.status = parseInt(status, 10);
      }
    });
  }

  private getRejectedMortgage() {
    this.authService.getRejectedMortgage().subscribe((resp) => (this.isRejected = resp));
  }

  openModalGeneric(status: string) {
    let titleModal = '';
    let message = '';

    switch (status) {
      case '1': {
        titleModal = this.translate.instant('status_bar_record_your_data');
        message = 'status_bar_record_your_data_info';
        break;
      }
      case '2': {
        titleModal = this.translate.instant('status_bar_send_document');
        message = 'status_bar_send_document_info';
        break;
      }
      case '3': {
        titleModal = this.translate.instant('status_bar_review');
        message = 'status_bar_review_info';
        break;
      }
      case '4': {
        titleModal = this.translate.instant('status_bar_appraisal');
        message = 'status_bar_appraisal_info';
        break;
      }
      case '5': {
        titleModal = this.translate.instant('status_bar_signature');
        message = 'status_bar_signature_info';
        break;
      }
      case '6': {
        titleModal = this.translate.instant('status_bar_inscription');
        message = 'status_bar_inscription_info';
        break;
      }
    }

    const data = {
      message: message,
    };
    const options: Object = {
      header: titleModal,
      showHeader: true,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    this.confirmationService.confirm(<any>{
      component: ModalGenericComponent,
      options: options,
      data: data,
      accept: (data) => {},
      reject: () => {},
    });
  }
}
